<template>
  <div class="appbox" :class="className">
    <div ref="wrapper" class="wrapper">
      <div v-if="!data.length" class="empty">暂无数据</div>
      <swiper :options="swiperOption" :key="className" ref="mySwiper">
        <swiper-slide :key="groupIdx" v-for="(group,groupIdx) in showDataList">
          <ul ref="applist" class="applist">
            <li :style="'margin-left:'+appRightMarginVal+'px'" @click="openExtraPage(item)" class="service-item"
                v-for="(item,index) in group">
              <div class="img-container">
                <div>
                  <img :src="item.icon" :alt="item.name"/>
                  <span v-if="isRecommend"><i class="iconfont icon-tuijian"></i></span>
                </div>
              </div>
              <div class="info-container">
                <h3>{{item.name}}</h3>
                <p>{{item.profile}}</p>
                <div class="star-container">
                  <rating :score='0'></rating>
                </div>
              </div>
              <div v-if="getSysIsInBuilding(item)" class="trangle">
                <span>建设中</span>
              </div>
            </li>
          </ul>
        </swiper-slide>
        <button v-show="data && data.length" slot="button-prev" class="pageTurn prev"><i
        class="iconfont icon-zuojiantou"></i></button>
        <button v-show="data && data.length" slot="button-next" class="pageTurn next"><i
        class="iconfont icon-youjiantou"></i></button>
      </swiper>
    </div>
  </div>
</template>

<script>
  import Bus from 'common/js/bus.js';

  //进一法
  Number.prototype.toCeil = function (num) {
    return Math.ceil(this * Math.pow(10, num)) / Math.pow(10, num);
  };

  //每个服务的宽度
  const APP_WIDTH = 266;

  import {swiper, swiperSlide} from 'vue-awesome-swiper'
  import rating from "components/globalComp/rating"

  export default {
    data() {
      return {

        currentSelectTabId: 0,
        //当前的数据指针
        currentDataRefer: 'data',
        swiperOption: {
          notNextTick: true,
          //循环
          loop: false,
          //设定初始化时slide的索引
          initialSlide: 0,
          //自动播放
          autoplay: false,
          // 设置轮播
          effect: 'slide',
          //滑动速度
          speed: 800,
          //滑动方向
          direction: 'horizontal',
          preventDefault: false,
          preventClicksPropagation: false,
          //小手掌抓取滑动
          grabCursor: true,
          //滑动之后回调函数
          on: {
            slideChangeTransitionEnd: function () {
              console.log(this.activeIndex);//切换结束时，告诉我现在是第几个slide
            },
          },
          //左右点击
          nextButton: '.next',
          prevButton: '.prev',

        },
        //==================
        showDataList: [],
        //Item右侧外边距
        appRightMarginVal: 0,

      }
    },
    props: {
      isRecommend: {
        type: Number,
        default: 0
      },
      data: {
        type: Array,
        default() {
          return []
        }
      },
      title: {
        type: String,
        default: "服务列表"
      },
      className: {
        type: String,
        default: null
      },
      desc: {
        type: String,
        default: "Service List"
      },
      microServiceList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    watch: {
      data(newVal) {
        this.initDataList()
      }
    },
    methods: {

      /*
      ** randomWord 产生任意长度随机字母数字组合
      ** randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
      ** xuanfeng 2014-08-28
      */
      randomWord: function (randomFlag, min, max) {
        let str = "",
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

        // 随机产生
        if (randomFlag) {
          range = Math.round(Math.random() * (max - min)) + min;
        }
        for (var i = 0; i < range; i++) {
          let pos = Math.round(Math.random() * (arr.length - 1));
          str += arr[pos];
        }
        return str;
      },
      initDataList() {
        if (!this.$refs.wrapper) {
          return;
        }
        console.log('%wrapper', 'color:#00f;font-size:50px');
        console.log(this.$refs.wrapper)
        let wrapper = this.$refs.wrapper;
        let itemCount = parseInt((wrapper.offsetWidth) / (170 + 40));
        this.appRightMarginVal = (wrapper.offsetWidth - (itemCount) * 170) / (itemCount + 1);
        let slideServiceList = [];
        let targetData = this[this.currentDataRefer]
        targetData.forEach((item, index) => {

          let groupNu = parseInt(index / itemCount);
          if (!slideServiceList[groupNu]) {
            slideServiceList[groupNu] = [];
          }
          slideServiceList[groupNu].push(item);
        })

        console.log(slideServiceList);
        this.showDataList = slideServiceList;
        this.maxIndex = this.showDataList.length - 1;
      },
      openExtraPage(item) {
        let url = item.pc_url;
        let title = item.name;
        window.open(url)
        //this.$modal.show("extraPage",{url,title});
      },
      getSysIsInBuilding(item) {
        let url = item.pc_url
        if (!url) {
          return
        }
        if (url.indexOf('building/index.jsp') !== -1) {
          return true
        }
        return false
      },
      //切换选项卡id
      changeSelectTab(item) {
        if (this.currentSelectTabId === item.id) {
          return
        }
        this.currentSelectTabId = item.id
        this.currentDataRefer = item.data
        this.initDataList()
      },
      //展示排序面板
      showSortPanel() {
        this.$modal.show('sysNavSort')
      }
    },
    mounted: function () {

      // let appWrapperDom=this.$refs.appWrapper;
      // let appMarginVal=parseInt((appWrapperDom.offsetWidth-50-APP_WIDTH*4)/4);
      // let containerWidthVal=((this.data.length+2)*(APP_WIDTH+appMarginVal))/2;
      // this.appRightMarginVal=appMarginVal+"px";
      // appWrapperDom.style.width=containerWidthVal+"px";
      // this.preGroupWidthVal=(APP_WIDTH+appMarginVal)*4;
      // this.maxIndex=containerWidthVal/((APP_WIDTH+appMarginVal)*4)-1;


      Bus.$on('refreshPersonalServiceTrain', (ev) => {
        this.initDataList();
      });
      window.addEventListener('resize', () => {
        this.initDataList()
      })
    },
    components: {swiper, swiperSlide, rating},
    computed: {
      //生成随机数
      remandStr: function () {
        return this.randomWord(true, 5, 8)
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../common/stylus/config.styl"
  .appbox
    & >>> .swiper-container
      text-align center

      button.pageTurn
        background-color transparent
        border 1px solid transparent
        height 26px
        transform scale(0.9)
        line-height 26px
        display inline-block
        margin-top 13px
        width 40px
        outline none


        &:hover
          color #006EC7

    h2
      height 50px
      width 100%
      line-height 50px
      background linear-gradient(#ffffff, #fafafa)
      color #333333
      border-bottom 1px solid #ebebeb
      position relative
      font-size 0
      z-index 9

      .tabList
        display inline-block

        li
          width 186px
          height 49px
          font-size 16px
          text-align center
          display inline-block
          cursor pointer
          color #666666

          &:first-of-type
            border-right 1px solid #e5e5e5

          &.on
            background-color #ffffff
            border-bottom 1px solid #efefef
            color #0059a3

          button
            border 1px solid #cccccc
            padding 1px 5px
            margin-left 5px
            border-radius 5px
            background-color #ffffff
            outline none
            transition 300ms
            color #666666

            i.iconfont
              font-size 12px

            &:hover
              background-color #f1f1f1

      .slide-list-nav
        position absolute
        right 150px
        top 0
        min-width 100px
        height 100%
        text-align right
        margin-right 24px
        cursor pointer
        line-height 2.8
        font-size 16px
        user-select none

        li.bullet
          display inline-block
          width 6px
          height 6px

          background-color #d8d8d8
          margin-right 10px

          &.on
            background-color #aaaaaa


          i
            color #ffffff

          &:nth-of-type(1), &.swiper-button-disabled:nth-of-type(1)
            border-right none

          &:nth-of-type(2)
            background-color #2e7dbc
            border 1px solid #2e76bf

          &.swiper-button-disabled
            background-color #f6f6f6 !important
            border 1px solid #dddddd

            i
              color #dddddd

      span
        color #cccccc
        margin-left 5px

    .wrapper
      position relative
      width 100%
      overflow-y hidden
      margin-top 15px
      .prev
        position absolute
        left 0
        top 40%
        z-index 10
      .next
        position absolute
        right 0
        top 40%
        z-index 10

      .applist
        padding 22px 0 8px
        width 100%
        transition 300ms
        background-color #ffffff

        &::after
          content ""
          display block
          width 100%
          height 0
          clear both

        li
          float left
          width 170px
          height 190px
          position relative
          /*margin-right 26px*/
          /*margin-bottom 12px*/
          cursor pointer
          transition 300ms
          transition-property box-shadow
          text-align center
          box-shadow 0px 2px 20px 0px rgba(28, 96, 130, 0.15)
          border-radius 10px

          &:nth-of-type(4n)
            margin-right 0

          &:hover
            box-shadow 2px 2px 10px #cccccc

          .img-container
            margin-top 25px
            position relative

            div
              display block
              text-align center

              img
                width 79px
                height 79px

              span
                position absolute
                display block
                border-radius 50%
                top 20px
                right 6px

                i
                  font-size 20px
                  color #77d878
                  background-color #ffffff
                  border-radius 50%

          .info-container

            h3, p
              white-space nowrap
              overflow hidden
              text-overflow ellipsis

            h3
              font-size 18px
              color #666666
              margin-top 20px
              padding 0 10px
              box-sizing border-box
              font-weight bold

            p
              font-size 14px
              color #999999
              margin-top 10px
              letter-spacing 0

            .star-container
              height 16px

          .trangle
            position absolute
            right 0
            top 0
            width 0
            height 0
            border-color #2b74b8 #2b74b8 transparent transparent
            border-width 20px 20px 20px 20px
            border-style solid
            color #fff
            font-size 12px
            white-space nowrap
            line-height 1

            span
              position absolute
              top -12px
              right -24px
              transform rotateZ(45deg) scale(0.9)

      .sys-nav-list
        padding 56px 12px 24px
        background-color #ffffff

        li
          width 75px
          float left
          margin 0 40px

          img
            width 100%
            height 75px
            border-radius 5px

          p
            color #666666
            font-size 14px
            text-align center
            line-height 38px

  .turn
    font-size 0
    display block
    user-select none
    text-align center

    button
      background-color #ffffff
      border 1px solid #ffffff
      height 26px
      transform scale(0.9)
      line-height 26px
      display inline-block
      margin-top 13px
      width 40px
      outline none

      &:hover
        color #006EC7

  .scroll-enter-active, .scroll-leave-active {
    transition: .3s;
  }

  .scroll-enter, .scroll-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    transform: translateX(100px);
    opacity: 0;
  }

  /*绿色版皮肤*/
  .green
    h2
      color greenThemeValue

    li.on
      color greenThemeValue !important

    .appbox h2 .turn button
      background-color greenThemeValue

    .next, .prev
      border 1px solid greenThemeValue !important
      background-color greenThemeValue !important

      &.swiper-button-disabled
        border 1px solid #dddddd !important
</style>



// WEBPACK FOOTER //
// src/components/personal/slideAppList.vue